// extracted by mini-css-extract-plugin
export default {"icon":"icons_icon__tWbDf","iconLarge":"icons_iconLarge__6n9B7","iconSmall":"icons_iconSmall__lMzOT","iconTiny":"icons_iconTiny__A2dNk","iconMicro":"icons_iconMicro__N8bsJ"};